import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 1 — Recruiting (ATS) + Onboarding shell. Sidebar nav + <Outlet/>,
 * mirroring the core HrShell layout (reuses the `hr-shell` CSS classes).
 */

const NAV = [
  { to: '/recruiting/requisitions', label: 'Requisitions', testid: 'recruiting-nav-requisitions' },
  { to: '/recruiting/candidates', label: 'Candidates', testid: 'recruiting-nav-candidates' },
  { to: '/recruiting/interviews', label: 'Interviews', testid: 'recruiting-nav-interviews' },
  { to: '/recruiting/offers', label: 'Offers', testid: 'recruiting-nav-offers' },
  { to: '/recruiting/onboarding', label: 'Onboarding', testid: 'recruiting-nav-onboarding' },
  { to: '/recruiting/templates', label: 'Journey Templates', testid: 'recruiting-nav-templates' },
];

export default function RecruitingShell() {
  return (
    <div className="hr-shell" data-testid="recruiting-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Recruiting</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink
                  to={n.to}
                  data-testid={n.testid}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
